/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

.add-medication-dialog {
  .MuiPaper-root {
    width: 500px;
    height: 450px;
  }
  .add-medication-dialog-confirmed {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    .check-circle {
      width: 52px;
      height: 52px;
    }
  }
}
